import Vue from 'vue';

Vue.component('vuetable-totalizer-transaction', () =>
    import(/* webpackChunkName: 'totalizer-transaction-index' */ './vuetable-totalizer-transaction.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/totalizer-transaction/index.js